export default "__VITE_ASSET__BdEHPUsE__"